module.exports = __webpack_public_path__ + "static/media/value_prop_img_1.3f7b80e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/TCH-WEB/value_prop_img_1.jpg
// module id = 1300
// module chunks = 0